window.addEventListener("phx:page-loading-stop", (info) => {
    if (info.detail.kind === "initial") {
        if (window.ga) {
            let page = window.top.location.pathname + window.top.location.search + window.top.location.hash;
            ga('set', 'page', page);
            ga('send', 'pageview');
        }
    }
})

let gaId = document.querySelector("meta[name='ga-id']").getAttribute("content");
if (gaId) {
    window.ga = window.ga || function () {
        (ga.q = ga.q || []).push(arguments)
    };
    ga.l = +new Date;
    ga('create', gaId, 'auto');
}